import React, { useState } from 'react';
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';

const moveGradient = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const AnimatedHeading: React.FC = () => {
  const theme = useTheme();
  const belowLg = useMediaQuery(theme.breakpoints.down('lg'));

  const numbers = Array.from({ length: 31 }, (_, i) =>
    i.toString().padStart(2, '0')
  );
  const [index, setIndex] = useState(30);
  const [isAnimating, setIsAnimating] = useState(false);

  const startScrollAnimation = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIndex(0);
    let current = 0;
    const interval = setInterval(() => {
      current += 1;
      if (current > 30) {
        clearInterval(interval);
        setIsAnimating(false);
      } else {
        setIndex(current);
      }
    }, 90);
  };

  const greetingTypoSx = {
    fontSize: { xs: '50px', sm: '50px', md: '72px' },
    fontWeight: 800,
    color: '#1E293B',
    textAlign: 'center',
    letterSpacing: 0,
    fontFamily: 'inherit',
    lineHeight: '1',
  };

  const aiTypoProps = {
    component: 'span',
    sx: {
      background: 'linear-gradient(90deg, #DB86F8, #006FD6, #DB86F8)',
      backgroundSize: '300% 300%',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      animation: `${moveGradient} 4s linear infinite`,
      fontSize: { xs: '50px', sm: '50px', md: '72px' },
      fontWeight: 800,
      display: 'inline-block',
    },
  };

  return (
    <Typography component="h1" sx={greetingTypoSx}>
      Boost Your Grades by{' '}
      {!belowLg ? (
        <Box
          onClick={startScrollAnimation}
          sx={{
            display: 'inline-block',
            height: '65px',
            width: '100px',
            overflow: 'hidden',
            verticalAlign: 'center',
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              transition: 'transform 0.7s ease-in-out',
              transform: `translateY(-${index * 72}px)`,
            }}
          >
            {numbers.map((num, idx) => (
              <Box
                key={idx}
                sx={{
                  height: '72px',
                  fontSize: { xs: '50px', sm: '50px', md: '72px' },
                  fontWeight: 800,
                  color: '#1E293B',
                  textAlign: 'center',
                }}
              >
                {num}
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        '30'
      )}
      % with <br />
      <Typography {...aiTypoProps}>AI-Powered</Typography> Learning
    </Typography>
  );
};

export default AnimatedHeading;
